//RECUPERACIÓN TWEEDG734HT43Q5QS5NNF496

export const BASE_URL = 'http://189.195.162.46:5354'
// CONEXIÓN A BACK END
export const request = async (url: string, method: string, body?: any, p0?: string) => {
    const options: RequestInit = {
        method,
        headers: {
            'Content-Type': 'application/json',
        },
        body: body ? JSON.stringify(body) : undefined,
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        throw new Error('Error en la petición');
    }

    return response.json();
};

// Registrar entidad "uso general"
export const registrarEntidad = (url: string, cve: string, nombre: string) => {
    const body = { cve, nombre };
    return request(url, 'POST', body);
};

export const obtenerUsuarios = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener los usuarios');
    return await response.json();
};

export const registrarSalida = async (url: string, data: any) => {
    return request(url, 'POST', data);
};

export const obtenerSalidas = async (url: string) => {
    return request(url, 'GET');
};

export const actualizarSalida = async (url: string, data: any) => {
    return request(url, 'PATCH', data);
};

export const eliminarSalida = async (url: string) => {
    return request(url, 'DELETE');
};
export const obtenerMantenimientoss = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener los mantenimientos');
    return await response.json();
};
// Obtener entidad "uso general"
export const obtenerEntidades = (url: string) => {
    return request(url, 'GET');
};

// Actualizar entidad "uso general"
export const actualizarEntidad = (url: string, nombre: string, id_linea?: number) => {
    const body = id_linea ? { nombre, id_linea } : { nombre };
    return request(url, 'PATCH', body);
};

export const obtenerProductos = async (obtener: string) => {
    const response = await fetch(API_URLS.productos.obtener);
    if (!response.ok) throw new Error('Error al obtener los productos');
    return await response.json();
};

// Eliminar entidad "uso general"
export const eliminarEntidad = (url: string) => {
    return request(url, 'DELETE');
};

// Registrar sublínea
export const registrarSublinea = (url: string, cve: string, nombre: string, cve_linea: string) => {
    const body = { cve_linea, cve, nombre };
    return request(url, 'POST', body);
};

// Obtener sublíneas
export const obtenerSublineas = (url: string) => {
    return request(url, 'GET');
};

// Obtener sublínea por cve_linea y cve
export const obtenerSublineaPorCve = (cve_linea: string, cve: string) => {
    return request(`${BASE_URL}/sublinea/getSublineaByCves/${cve_linea}/${cve}`, 'GET');
};

// Actualizar sublínea
export const actualizarSublinea = (url: string, cveLinea: string, cve: string, nombre: string) => {
    const body = { nombre };
    return request(url, 'PATCH', body);
};

// Eliminar sublínea
export const eliminarSublinea = (url: string) => {
    return request(url, 'DELETE');
};

// Funciones para Entradas
export const registrarEntrada = async (url: string, data: any) => {
    return request(url, 'POST', data);
};

export const obtenerEntradas = async (url: string) => {
    return request(url, 'GET');
};

export const actualizarEntrada = async (url: string, data: any) => {
    return request(url, 'PATCH', data);
};

export const obtenerMantenimientos = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener los mantenimientos');
    return await response.json();
};

export const eliminarEntrada = async (url: string) => {
    return request(url, 'DELETE');
};

export const obtenerUltimoFolio = async (url: string): Promise<number> => {
    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Error al obtener los datos');

        const data = await response.json();

        // Si hay datos, encuentra el mayor folio
        const folios = data.map((item: { folio: string }) => parseInt(item.folio));
        return folios.length > 0 ? Math.max(...folios) : 0;

    } catch (error) {
        console.error("Error al obtener el último folio:", error);
        return 0;
    }
};

// Fuera de API_URLS:
export const registrarTraspaso = async (url: string, data: any) => {
    return request(url, 'POST', data);
};

export const obtenerTraspasos = async (url: string) => {
    return request(url, 'GET');
};

export const obtenerProductosParaTraspaso = async () => {
    try {
        const response = await fetch(API_URLS.traspasos.getProductos);
        if (!response.ok) throw new Error('Error al obtener los productos');
        return await response.json();
    } catch (error) {
        console.error('Error al obtener productos:', error);
        return [];
    }
};

export const obtenerSucursalesParaTraspaso = async () => {
    try {
        const response = await fetch(API_URLS.traspasos.getSucursales);
        if (!response.ok) throw new Error('Error al obtener las sucursales');
        return await response.json();
    } catch (error) {
        console.error('Error al obtener sucursales:', error);
        return [];
    }
};

export const obtenerDepartamentosParaTraspaso = async () => {
    try {
        const response = await fetch(API_URLS.traspasos.getDepartamentos);
        if (!response.ok) throw new Error('Error al obtener los departamentos');
        return await response.json();
    } catch (error) {
        console.error('Error al obtener departamentos:', error);
        return [];
    }
};

//  **FUNCIONES DE WHATSAPP** 
// Interface para los datos de entrada que se envían por WhatsApp
interface EntradaWhatsAppData {
    folio: string;
    fecha: string;
    proveedor: string;
    referencia: string;
    observaciones?: string;
    productos: Array<{
        producto: string;
        descripcion: string;
        cantidad: number;
    }>;
    usuario?: string;
}

/**
 * 📱 FUNCIÓN PRINCIPAL - Solo pasa el JSON y se envía automáticamente
 * @param entradaData - Datos de la entrada en formato JSON
 * @returns Promise<boolean> - true si se envió exitosamente
 */
export const enviarEntradaPorWhatsApp = async (entradaData: EntradaWhatsAppData): Promise<boolean> => {
    try {
        console.log('📱 Enviando entrada por WhatsApp:', entradaData.folio);

        // Preparar datos con valores por defecto
        const datosCompletos = {
            folio: entradaData.folio,
            fecha: entradaData.fecha,
            proveedor: entradaData.proveedor,
            referencia: entradaData.referencia,
            observaciones: entradaData.observaciones || '',
            productos: entradaData.productos || [],
            totalProductos: entradaData.productos?.length || 0,
            usuario: entradaData.usuario || localStorage.getItem('nombreUsuario') || 'Usuario desconocido'
        };

        // Enviar al backend
        const response = await fetch(API_URLS.whatsapp.enviarEntrada, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(datosCompletos)
        });

        const resultado = await response.json();

        if (response.ok && resultado.success) {
            console.log('✅ WhatsApp enviado exitosamente:', resultado);
            return true;
        } else {
            console.warn('⚠️ Problemas al enviar WhatsApp:', resultado);
            return resultado.resultados?.exitosos > 0 || false;
        }

    } catch (error) {
        console.error('❌ Error al enviar WhatsApp:', error);
        return false;
    }
};

/**
 * 🔄 Reenviar WhatsApp de una entrada existente (solo necesitas el folio)
 * @param folio - Folio de la entrada
 * @returns Promise<boolean>
 */
export const reenviarWhatsAppEntrada = async (folio: string): Promise<boolean> => {
    try {
        console.log('🔄 Reenviando WhatsApp para folio:', folio);

        const response = await fetch(API_URLS.whatsapp.reenviar(folio), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const resultado = await response.json();
        
        if (response.ok && resultado.success) {
            console.log('✅ WhatsApp reenviado exitosamente');
            return true;
        } else {
            console.error('❌ Error al reenviar WhatsApp:', resultado);
            return false;
        }

    } catch (error) {
        console.error('❌ Error al reenviar WhatsApp:', error);
        return false;
    }
};

/**
 * 👀 Obtener preview del mensaje de WhatsApp (para testing)
 * @param folio - Folio de la entrada
 * @returns Promise<any> - Datos formateados y preview del mensaje
 */
export const obtenerPreviewWhatsApp = async (folio: string) => {
    try {
        const response = await fetch(API_URLS.whatsapp.preview(folio));
        
        if (!response.ok) {
            throw new Error('Error al obtener preview');
        }

        return await response.json();

    } catch (error) {
        console.error('Error al obtener preview WhatsApp:', error);
        return null;
    }
};

/**
 * ⚙️ Obtener configuración actual de WhatsApp
 * @returns Promise<any> - Configuración actual (números, etc.)
 */
export const obtenerConfigWhatsApp = async () => {
    try {
        const response = await fetch(API_URLS.whatsapp.config);
        return await response.json();
    } catch (error) {
        console.error('Error al obtener configuración WhatsApp:', error);
        return null;
    }
};

/**
 * 📞 Actualizar números de destino para WhatsApp
 * @param numeros - Array de números en formato whatsapp:+número
 * @returns Promise<boolean>
 */
export const actualizarNumerosWhatsApp = async (numeros: string[]): Promise<boolean> => {
    try {
        const response = await fetch(API_URLS.whatsapp.config, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ toNumbers: numeros })
        });

        const resultado = await response.json();
        return response.ok && resultado.success;

    } catch (error) {
        console.error('Error al actualizar números WhatsApp:', error);
        return false;
    }
};

// Funciones específicas para empleados
export const obtenerEmpleados = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener los empleados');
    return await response.json();
};

export const registrarEmpleado = async (url: string, data: any) => {
    return request(url, 'POST', data);
};

export const actualizarEmpleado = async (url: string, data: any) => {
    return request(url, 'PATCH', data);
};

export const eliminarEmpleado = async (url: string) => {
    return request(url, 'DELETE');
};

// Función para cambiar contraseña de empleado
export const cambiarPasswordEmpleado = async (url: string, data: any) => {
    return request(url, 'PATCH', data);
};

// Funciones específicas para peticiones
export const obtenerPeticiones = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener las peticiones');
    return await response.json();
};

export const registrarPeticion = async (url: string, data: any) => {
    return request(url, 'POST', data);
};

export const actualizarPeticion = async (url: string, data: any) => {
    return request(url, 'PATCH', data);
};

export const eliminarPeticion = async (url: string) => {
    return request(url, 'DELETE');
};

export const obtenerPeticionPorFolio = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener la petición');
    return await response.json();
};

export const obtenerPeticionesPorEmpleado = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener las peticiones del empleado');
    return await response.json();
};

// **FUNCIONES ESPECÍFICAS PARA LICENCIAS**
export const obtenerLicencias = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener las licencias');
    return await response.json();
};

export const registrarLicencia = async (url: string, data: any) => {
    return request(url, 'POST', data);
};

export const actualizarLicencia = async (url: string, data: any) => {
    return request(url, 'PUT', data);
};

export const eliminarLicencia = async (url: string) => {
    return request(url, 'DELETE');
};

export const obtenerLicenciaPorId = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener la licencia');
    return await response.json();
};

export const obtenerLicenciasPorEmpleado = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener las licencias del empleado');
    return await response.json();
};

export const obtenerLicenciasPorEstatus = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener las licencias por estatus');
    return await response.json();
};

export const cambiarEstatusLicencia = async (url: string, data: any) => {
    return request(url, 'PATCH', data);
};

export const obtenerEstadisticasLicencias = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener las estadísticas de licencias');
    return await response.json();
};

// **FUNCIONES ESPECÍFICAS PARA SERVIDORES**
export const obtenerServidores = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener los servidores');
    return await response.json();
};

export const registrarServidor = async (url: string, data: any) => {
    return request(url, 'POST', data);
};

export const actualizarServidor = async (url: string, data: any) => {
    return request(url, 'PUT', data);
};

export const eliminarServidor = async (url: string) => {
    return request(url, 'DELETE');
};

export const obtenerServidorPorId = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener el servidor');
    return await response.json();
};

export const obtenerServidoresPorSucursal = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener los servidores por sucursal');
    return await response.json();
};

export const buscarServidoresPorNombre = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al buscar servidores por nombre');
    return await response.json();
};

export const obtenerEstadisticasServidores = async (url: string) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Error al obtener las estadísticas de servidores');
    return await response.json();
};

// **API URLs**
export const API_URLS = {
    sucursales: {
        registrar: `${BASE_URL}/sucursal/registrarSucursal`,
        obtener: `${BASE_URL}/sucursal/getsucursales`,
        actualizar: (id: string) => `${BASE_URL}/sucursal/actualizarSucursal/${id}`,
        eliminar: (id: string) => `${BASE_URL}/sucursal/eliminarSucursal/${id}`,
    },
    departamentos: {
        registrar: `${BASE_URL}/departamento/registrarDepartamento`,
        obtener: `${BASE_URL}/departamento/getDepartamentos`,
        obtenerPorCve: (cve: string) => `${BASE_URL}/departamento/getDepartamentoByCve/${cve}`,
        actualizar: (cve: string) => `${BASE_URL}/departamento/actualizarDepartamento/${cve}`,
        eliminar: (cve: string) => `${BASE_URL}/departamento/eliminarDepartamento/${cve}`,
    },
    usuarios: {
        registrar: `${BASE_URL}/usuario/registrarUsuario`,
        enviarlogin: `${BASE_URL}/usuario/login`,
        obtener: `${BASE_URL}/usuario/getUsuarios`,
        obtenerPorId: (id: string) => `${BASE_URL}/usuario/getUsuarioByID/${id}`,
        actualizar: (id: string) => `${BASE_URL}/usuario/actualizarUsuario/${id}`,
        eliminar: (id: string) => `${BASE_URL}/usuario/eliminarUsuario/${id}`,
    },
    empleados: {
        registrar: `${BASE_URL}/empleado/registrarEmpleado`,
        enviarlogin: `${BASE_URL}/empleado/login`,
        obtener: `${BASE_URL}/empleado/getEmpleados`,
        obtenerPorCve: (cveemp: string) => `${BASE_URL}/empleado/getEmpleadoByID/${cveemp}`,
        actualizar: (cveemp: string) => `${BASE_URL}/empleado/actualizarEmpleado/${cveemp}`,
        eliminar: (cveemp: string) => `${BASE_URL}/empleado/eliminarEmpleado/${cveemp}`,
        cambiarPassword: `${BASE_URL}/empleado/cambiarPassword`,
    },
    proveedores: {
        registrar: `${BASE_URL}/proveedor/registrarProveedor`,
        obtener: `${BASE_URL}/proveedor/getProveedores`,
        actualizar: (id: string) => `${BASE_URL}/proveedor/actualizarProveedor/${id}`,
        eliminar: (id: string) => `${BASE_URL}/proveedor/eliminarProveedor/${id}`,
    },
    lineas: {
        registrar: `${BASE_URL}/linea/registrarLinea`,
        obtener: `${BASE_URL}/linea/getLineas`,
        obtenerPorCve: (cve: string) => `${BASE_URL}/linea/getLineaByCve/${cve}`,
        actualizar: (cve: string) => `${BASE_URL}/linea/actualizarLinea/${cve}`,
        eliminar: (cve: string) => `${BASE_URL}/linea/eliminarLinea/${cve}`,
    },
    marcas: {
        registrar: `${BASE_URL}/marca/registrarMarca`,
        obtener: `${BASE_URL}/marca/getMarcas`,
        obtenerPorCve: (cve: string) => `${BASE_URL}/marca/getMarcaByCve/${cve}`,
        actualizar: (cve: string) => `${BASE_URL}/marca/actualizarMarca/${cve}`,
        eliminar: (cve: string) => `${BASE_URL}/marca/eliminarMarca/${cve}`,
    },
    unidades: {
        registrar: `${BASE_URL}/unidad/registrarUnidad`,
        obtener: `${BASE_URL}/unidad/getUnidades`,
        obtenerPorCve: (cve: string) => `${BASE_URL}/unidad/getUnidadByCve/${cve}`,
        actualizar: (cve: string) => `${BASE_URL}/unidad/actualizarUnidad/${cve}`,
        eliminar: (cve: string) => `${BASE_URL}/unidad/eliminarUnidad/${cve}`,
    },
    Sublineas: {
        registrar: `${BASE_URL}/sublinea/registrarSublinea`,
        obtener: `${BASE_URL}/sublinea/getSublineas`,
        obtenerPorCve: (cve_linea: string, cve: string) => `${BASE_URL}/sublinea/getSublineaByCves/${cve_linea}/${cve}`,
        actualizar: (cveLinea: string, cve: string) => `${BASE_URL}/sublinea/actualizarSublinea/${cveLinea}/${cve}`,
        eliminar: (cve_linea: string, cve: string) => `${BASE_URL}/sublinea/eliminarSublinea/${cve_linea}/${cve}`,
    },
    productos: {
        registrar: `${BASE_URL}/producto/registrarProducto`,
        obtener: `${BASE_URL}/producto/getProductos`,
        obtenerPorCve: (cve: string) => `${BASE_URL}/producto/getProductoByCve/${cve}`,
        actualizar: (cve: string) => `${BASE_URL}/producto/actualizarProducto/${cve}`,
        eliminar: (cve: string) => `${BASE_URL}/producto/eliminarProducto/${cve}`,
    },
    entradas: {
        registrar: `${BASE_URL}/entrada/registrarEntrada`,
        obtener: `${BASE_URL}/entrada/getEntradas`,
        obtenerPorFolio: (folio: string) => `${BASE_URL}/entrada/getEntradaByFolio/${folio}`,
        actualizar: (folio: string) => `${BASE_URL}/entrada/actualizarEntrada/${folio}`, 
        eliminar: (folio: string) => `${BASE_URL}/entrada/eliminarEntrada/${folio}`,
    },
    salidas: {
        registrar: `${BASE_URL}/salida/registrarSalida`,
        obtener: `${BASE_URL}/salida/getSalidas`,
        obtenerPorFolio: (folio: string) => `${BASE_URL}/salida/getSalidaByFolio/${folio}`,
        actualizar: (folio: string) => `${BASE_URL}/salida/actualizarSalida/${folio}`,
        eliminar: (folio: string) => `${BASE_URL}/salida/eliminarSalida/${folio}`,
    },
    mantenimientos: {
        registrar: `${BASE_URL}/mantenimiento/registrar`,
        obtener: `${BASE_URL}/mantenimiento/getMantenimientos`,
        obtenerPorFolio: (folio: string) => `${BASE_URL}/mantenimiento/getMantenimientoByFolio/${folio}`,
        actualizar: (folio: string) => `${BASE_URL}/mantenimiento/actualizarMantenimiento/${folio}`,
        eliminar: (folio: string) => `${BASE_URL}/mantenimiento/eliminarMantenimiento/${folio}`,
        detalles: {
            obtenerPorFolio: (folio: string) => `${BASE_URL}/mantenimiento/getDetallesByFolio/${folio}`,
            eliminar: (folio: string, id: number) => `${BASE_URL}/mantenimiento/eliminarDetalle/${folio}/${id}`
        }
    },
    traspasos: {
        registrar: `${BASE_URL}/traspasos`,
        obtener: `${BASE_URL}/traspasos`,
        obtenerPorId: (id: string) => `${BASE_URL}/traspasos/${id}`,
        actualizar: (id: string) => `${BASE_URL}/traspasos/${id}`,
        eliminar: (id: string) => `${BASE_URL}/traspasos/${id}`,
        getProductos: `${BASE_URL}/traspasos/productos`,
        getSucursales: `${BASE_URL}/traspasos/sucursales`,
        getDepartamentos: `${BASE_URL}/traspasos/departamentos`,
    },
    whatsapp: {
        enviarEntrada: `${BASE_URL}/entrada/enviar-whatsapp`,
        reenviar: (folio: string) => `${BASE_URL}/entrada/reenviar-whatsapp/${folio}`,
        preview: (folio: string) => `${BASE_URL}/entrada/datos-whatsapp/${folio}`,
        config: `${BASE_URL}/whatsapp/config`,
    },
    peticiones: {
        // CRUD básico
        registrar: `${BASE_URL}/peticion/registrarPeticion`,
        obtener: `${BASE_URL}/peticion/getPeticiones`,
        obtenerPorFolio: (folio: string) => `${BASE_URL}/peticion/getPeticionByFolio/${folio}`,
        obtenerPorEmpleado: (cveemp: string) => `${BASE_URL}/peticion/getPeticionesByEmpleado/${cveemp}`,
        obtenerPorEstatus: (estatus: string) => `${BASE_URL}/peticion/getPeticionesByEstatus/${estatus}`,
        obtenerPorTecnico: (tecnicoId: string) => `${BASE_URL}/peticion/getPeticionesByTecnico/${tecnicoId}`,
        obtenerSinTecnico: `${BASE_URL}/peticion/getPeticionesSinTecnico`,
        obtenerPendientesConfirmacion: `${BASE_URL}/peticion/getPeticionesPendientesConfirmacion`,
        obtenerConfirmadas: `${BASE_URL}/peticion/getPeticionesConfirmadas`,
        
        // Actualizaciones
        actualizar: (folio: string) => `${BASE_URL}/peticion/actualizarPeticion/${folio}`,
        
        // 🔥 RUTA ESPECÍFICA PARA CAMBIO DE ESTATUS CON NOTIFICACIONES A EMPLEADOS
        actualizarEstatus: (folio: string) => `${BASE_URL}/peticion/actualizarEstatusPeticion/${folio}`,
        
        asignarTecnico: (folio: string) => `${BASE_URL}/peticion/asignarTecnico/${folio}`,
        actualizarFechaPromesa: (folio: string) => `${BASE_URL}/peticion/actualizarFechaPromesa/${folio}`,
        actualizarMotivo: (folio: string) => `${BASE_URL}/peticion/actualizarMotivo/${folio}`,
        confirmar: (folio: string) => `${BASE_URL}/peticion/confirmarPeticion/${folio}`,
        eliminar: (folio: string) => `${BASE_URL}/peticion/eliminarPeticion/${folio}`,
        
        // Técnicos
        obtenerTecnicos: `${BASE_URL}/peticion/getTecnicosDisponibles`,
        
        // Imágenes - RUTAS CORREGIDAS
        obtenerImagen: (folio: string) => `${BASE_URL}/peticion/getImagenPeticion/${folio}`,
        obtenerImagen2: (folio: string) => `${BASE_URL}/peticion/getImagen2Peticion/${folio}`,
        verificarImagen: (folio: string) => `${BASE_URL}/peticion/verificarImagenPeticion/${folio}`,
        verificarImagen2: (folio: string) => `${BASE_URL}/peticion/verificarImagen2Peticion/${folio}`,
        
        // WhatsApp específico para peticiones
        whatsappStatus: `${BASE_URL}/peticion/whatsapp/status`,
        whatsappGroups: `${BASE_URL}/peticion/whatsapp/groups`,
        whatsappTest: `${BASE_URL}/peticion/whatsapp/test`,
        whatsappTestGroup: `${BASE_URL}/peticion/whatsapp/test-group`,
        whatsappReconnect: `${BASE_URL}/peticion/whatsapp/reconnect`
    },
    licencias: {
        // CRUD básico
        registrar: `${BASE_URL}/licencias`,
        obtener: `${BASE_URL}/licencias`,
        obtenerPorId: (id: string) => `${BASE_URL}/licencias/${id}`,
        actualizar: (id: string) => `${BASE_URL}/licencias/${id}`,
        eliminar: (id: string) => `${BASE_URL}/licencias/${id}`,
        
        // Consultas específicas
        obtenerPorEmpleado: (cveemp: string) => `${BASE_URL}/licencias/empleado/${cveemp}`,
        obtenerPorEstatus: (estatus: string) => `${BASE_URL}/licencias/estatus/${estatus}`,
        
        // Operaciones especiales
        cambiarEstatus: (id: string) => `${BASE_URL}/licencias/${id}/estatus`,
        obtenerEstadisticas: `${BASE_URL}/licencias/estadisticas`,
    },
    servidores: {
        // CRUD básico
        registrar: `${BASE_URL}/server/registrarServidor`,
        obtener: `${BASE_URL}/server/getServidores`,
        obtenerPorId: (id: string) => `${BASE_URL}/server/getServidorById/${id}`,
        actualizar: (id: string) => `${BASE_URL}/server/actualizarServidor/${id}`,
        eliminar: (id: string) => `${BASE_URL}/server/eliminarServidor/${id}`,
        
        // Consultas específicas
        obtenerPorSucursal: (sucursal: string) => `${BASE_URL}/server/getServidoresBySucursal/${sucursal}`,
        buscarPorNombre: (nombre: string) => `${BASE_URL}/server/buscarServidoresPorNombre/${nombre}`,
        
        // Estadísticas
        obtenerEstadisticas: `${BASE_URL}/server/getEstadisticasServidores`,
    },
    bitacora: {
    registrar: `${BASE_URL}/bitacora/registrarBitacora`,
    obtenerTodas: `${BASE_URL}/bitacora/getBitacoras`,
    obtenerPorId: (id: number) => `${BASE_URL}/bitacora/getBitacora/${id}`,
    obtenerPorProducto: (cve: string) => `${BASE_URL}/bitacora/getBitacorasByProducto/${cve}`,
    actualizar: (id: number) => `${BASE_URL}/bitacora/actualizarBitacora/${id}`,
    eliminar: (id: number) => `${BASE_URL}/bitacora/eliminarBitacora/${id}`,
},
rustdesk: {
    obtener: `${BASE_URL}/rustdesk/getRustdesk`,
    registrar: `${BASE_URL}/rustdesk/registrarRustdesk`,
    actualizar: (id: string) => `${BASE_URL}/rustdesk/actualizarRustdesk/${id}`,
    eliminar: (id: string) => `${BASE_URL}/rustdesk/eliminarRustdesk/${id}`,
},
rust: {
    obtener: `${BASE_URL}/rust/getRust`,
    registrar: `${BASE_URL}/rust/registrarRust`,
    actualizar: (id: string) => `${BASE_URL}/rust/actualizarRust/${id}`,
    eliminar: (id: string) => `${BASE_URL}/rust/eliminarRust/${id}`,
},
    base: BASE_URL,
};